let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jzNYH")).then(() => parcelRequire('4PDkD'));